import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Internal dependencies
 */

const ToolbarGroupContainer = ({
  className,
  children,
  ...props
}) => /*#__PURE__*/_jsx("div", {
  className: className,
  ...props,
  children: children
});
export default ToolbarGroupContainer;